import { useEffect, useState } from 'react';
import { useChat } from '../store/chat';

export function ConnectionBanner() {
  const connection = useChat((s) => s.connection);
  // Short reconnects are normal (network switch, app resume); avoid flashing the banner.
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (connection === 'online') return setShow(false);
    const t = setTimeout(() => setShow(true), connection === 'offline' ? 0 : 1500);
    return () => clearTimeout(t);
  }, [connection]);
  if (!show) return null;
  return (
    <div className={`banner banner-${connection}`} role="status">
      {connection === 'offline' ? 'Нет подключения к интернету' : 'Подключение…'}
    </div>
  );
}
